import { instance, instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';

export const getWorkerShift = (
  params: Types.GetWorkerRequest
): AxiosPromise<Types.GetWorkerResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/schedules',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getWorkerShiftTrustConstructionManagement = (
  params: Types.GetWorkerRequest
): AxiosPromise<Types.GetWorkerResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/schedules/bo-01-01',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getWorkerStatus = (
  params: Types.GetWorkerStatusRequest
): AxiosPromise<Types.GetWorkerStatusResponse> => {
  const request: AxiosRequestConfig = {
    url: '/worker_status',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getWorkRisk = (
  params: Types.GetWorkRiskRequest
): AxiosPromise<Types.GetWorkRiskResponse> => {
  const request: AxiosRequestConfig = {
    url: '/work_risk',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getWorkerChangeSite = (
  params: Types.GetWorkersChargeSiteRequest
): AxiosPromise<Types.GetWorkersChargeSiteResponse> => {
  const request: AxiosRequestConfig = {
    url: '/workers_charge_site_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getWorkerSchedules = (
  params: Types.GetSiteUserRequest
): AxiosPromise<Types.GetSiteUserResponse> => {
  const request: AxiosRequestConfig = {
    url: '/site/user/schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// /performance
export const getPerformance = (
  params: Types.GetPerformanceRequest
): AxiosPromise<Types.GetPerformanceResponse> => {
  const request: AxiosRequestConfig = {
    url: '/performance',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// 2025/02/25 FJ 3月分反映分 NO32 start
// /getPerformanceGroup
export const getPerformanceGroup = (
  params: Types.GetPerformanceGroupRequest
): AxiosPromise<Types.GetPerformanceResponse> => {
  const request: AxiosRequestConfig = {
    url: '/performance/group',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2025/02/25 FJ 3月分反映分 NO32 end

// /performance
export const getPerformanceWorkArea = (
  params: Types.GetPerformanceWorkAreaRequest
): AxiosPromise<Types.GetPerformanceWorkAreaResponse> => {
  const request: AxiosRequestConfig = {
    url: '/performance/work_area',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getListTestScaffold = (
  params: Types.GetTestScaffoldRequest
): AxiosPromise<Types.GetTestScaffoldResponse> => {
  const request: AxiosRequestConfig = {
    url: '/worker/list_test_scaffold',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getSafetyInstructions = (
  params: Types.GetSafetyInstructionsRequest
): AxiosPromise<Types.GetSafetyInstructionsResponse> => {
  const request: AxiosRequestConfig = {
    url: '/worker/safety_nstructions',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const getDataGanttSupportSite = (
  params: Types.GetWorkerRequest
): AxiosPromise<Types.GetWorkerResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/dataC-gantt-support',
    method: 'GET',
    params,
  };
  return instance(request);
};

export const postInformation = (
  data: Types.PostInformationRequest
): AxiosPromise<Types.PostInformationResponse> => {
  const request: AxiosRequestConfig = {
    url: '/information/new',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const postStamp = (data: Types.PostStampRequest): AxiosPromise<Types.PostStampResponse> => {
  const request: AxiosRequestConfig = {
    url: '/stamp/modify',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

export const postPerformanceUpdate = (
  data: Types.PostPerformanceRequest
): AxiosPromise<Types.PostPerformanceResponse> => {
  const request: AxiosRequestConfig = {
    url: '/performance/update',
    method: 'POST',
    data,
  };
  return instanceApi(request);
};

//schedules

export const getUserStatusChart = (
  params: Types.GetUserStatusesRequest
): AxiosPromise<Types.GetUserStatusesResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/work/schedule_list',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

export const getUserHealthChart = (
  params: Types.GetUserHealthRequest
): AxiosPromise<Types.GetUserHealthResponse> => {
  const request: AxiosRequestConfig = {
    url: '/user/health',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

//api/v1/sites/shop_schedules

export const getShopSchedules = (
  params: Types.GetShopScheduleRequest
): AxiosPromise<Types.GetShopScheduleResponse> => {
  const request: AxiosRequestConfig = {
    url: '/sites/shop_schedules',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

//get Information

export const getInformation = (
  params: Types.GetInformationRequest
): AxiosPromise<Types.GetInformationResponse> => {
  const request: AxiosRequestConfig = {
    url: '/information/unread_count',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};

// get work_type

export const getWorkType = (
  params: Types.GetWorkerTypeRequest
): AxiosPromise<Types.GetWorkerType[]> => {
  const request: AxiosRequestConfig = {
    url: '/work_type',
    method: 'GET',
  };
  return instanceApi(request);
};

// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 start
export const getPerformanceWorkType = (
  params: Types.GetPerformanceWorkerTypeRequest
): AxiosPromise<Types.GetPerformanceWorkerTypeResponse> => {
  const request: AxiosRequestConfig = {
    url: '/performance/work_type',
    method: 'GET',
    params,
  };
  return instanceApi(request);
};
// 2023/04/26 Leading Win WEB側写真合成の工種の選択肢不正対応 end
